import { render, staticRenderFns } from "./ChatThemeSettings.vue?vue&type=template&id=6ed4f703&scoped=true"
import script from "./ChatThemeSettings.vue?vue&type=script&lang=js"
export * from "./ChatThemeSettings.vue?vue&type=script&lang=js"
import style0 from "./ChatThemeSettings.vue?vue&type=style&index=0&id=6ed4f703&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed4f703",
  null
  
)

export default component.exports